module.exports = __webpack_public_path__ + "img/gal_4.85cc22e7.png";